import SkeletonLoader from './SkeletonLoader';

export default SkeletonLoader;
